export const renderMedia = (imagePath) => {
        console.log('renderMedia called with:', imagePath);
        if (imagePath) {
            // Convert backslashes to forward slashes for URLs
            const normalizedPath = imagePath.replace(/\\/g, '/');
            
            // Check if it's already a full URL (http:// or https://)
            const isFullUrl = normalizedPath.startsWith('http://') || normalizedPath.startsWith('https://');
            const isAzureBlobUrl = normalizedPath.startsWith("https://sqlvaicpdkscvwnsyc.blob.core.windows.net/");
            const isLinkedInAsset = normalizedPath.includes('linkedin.com') || normalizedPath.includes('media.licdn.com');

            // Extract file extension (handle URLs with query parameters)
            const pathWithoutQuery = normalizedPath.split('?')[0];
            const fileExtension = pathWithoutQuery.split('.').pop().toLowerCase();

            let fileUrl;
            if (isFullUrl || isAzureBlobUrl || isLinkedInAsset) {
                // Use full URL directly for external URLs, Azure blob, or LinkedIn assets
                fileUrl = normalizedPath;
            } else {
                // For relative paths, prepend API base URL
                fileUrl = `${process.env.REACT_APP_API_BASE_URL}/${normalizedPath}`;
            }

            console.log('File URL:', fileUrl);
            console.log('File extension:', fileExtension);
            console.log('Is full URL:', isFullUrl);

            if (['mp4', 'mov', 'avi'].includes(fileExtension)) {
                return (
                    <div className='mt-3 mb-3 text-center'>
                        <video width="320" height="240" controls>
                            <source src={fileUrl} type={`video/${fileExtension}`} />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                );
            } else if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExtension) || isLinkedInAsset || isFullUrl) {
                return (
                    <div className='mt-3 mb-3 text-center'>
                        <img 
                            src={fileUrl} 
                            alt="Post Media" 
                            style={{ 
                                width: '150px', 
                                height: '150px', 
                                objectFit: 'cover', 
                                borderRadius: '8px',
                                display: 'block',
                                margin: '0 auto'
                            }}
                            onError={(e) => {
                                console.error('Image failed to load:', fileUrl);
                                e.target.style.display = 'none';
                            }}
                        />
                    </div>
                );
            }
        }
        console.warn('renderMedia: Unsupported file type or invalid path:', imagePath);
        return null;
    };